import React, { lazy, Suspense } from 'react';
import { Route, Routes } from "react-router-dom";
import Loader from './components/loader/loader';
import PrivateRoute from './pages/PrivateRoutes';
import Layout from './components/layout/layout.js';
import OnlyHeaderLayout from './components/layout/onlyHeaderLayout.js';
import NoHeaderFooterLayout from './components/layout/noHeaderFooterLayout.js';


  const LoginPage = lazy(() => import("./pages/loginPage/loginPage"));
  const SignupPage = lazy(() => import("./pages/signup/SignupPage"));
  const ForgotPassword = lazy(() => import("./pages/forgotPassword/forgotPassword"));
  const ResetPassword = lazy(() => import("./pages/resetPassword/resetPassword"));
  const EmailVerification = lazy(() => import("./pages/emailVerification/emailVerfication"));
  const ProductDetail = lazy(() => import("./pages/productDetail/productDetail"));
  const DashboardPage = lazy(() => import("./pages/dashboardPage/dashboardPage"));
  const Cart = lazy(() => import("./pages/cart/cart"));
  const BookInfo = lazy(() => import("./pages/bookInfo/bookInfo"));
  const AllPages = lazy(() => import("./pages/allPages/allPages"));
  const Checkout = lazy(() => import("./pages/cart/checkout"));
  const Success = lazy(() => import("./pages/cart/success"));
  const Failure = lazy(() => import("./pages/cart/failure"));
  // const Collage = lazy(() => import("./pages/collage/collage"));
  const Home = lazy(() => import("./pages/homePage/homePage"));
  const ViewPdf = lazy(() => import("./components/allpages/ViewPdf"));
  const BuyAVoucher = lazy(() => import("./pages/buyVoucher/buyVoucher"));
  const Contactus = lazy(() => import("./pages/contact/contact"));
  const CMSPages = lazy(() => import("./pages/cmsPages/cms.js"));
  const FAQ = lazy(()=> import("./pages/faq/faq"));
  const Blogs = lazy(() => import("./pages/blogs/blogs"));
  const BlogDetail = lazy(() => import("./pages/blogs/blogDetail"));
  const ManageAccount = lazy(() => import("./pages/manageAccount/manageAccount.js"));
  const NewsletterUnsubscribe = lazy(() => import("./pages/newsLetterUnsubscribe/newsletterUnsubscribe.js"));
  const VerifyGuest = lazy(() => import("./pages/guestUserVerification/verifyGuest.js"));
  const AddMessage = lazy(() => import("./pages/guestUserAddMessage/addMessage.js"));
  const NotFound = lazy(() => import("./pages/NotFound/notFound.js"));
  const OrderHistory = lazy(() => import("./pages/order/orderHistory.js"));
  const OrderDetails = lazy(() => import("./pages/order/orderDetails.js"));
  const PrintOrderDetails = lazy(() => import("./pages/order/printOrderDetails.js"));
  const ManagePaymentMethods = lazy(() => import("./pages/managePaymentMethods.js"));

const AppRoutes = () => {
    return(
      <Suspense fallback={<Loader />}>
      <Routes>
        {/* Public Routes  */}
        <Route element={<Layout />}> 
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/account/emailverification" element={<EmailVerification />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/account/reset-password" element={<ResetPassword />} />
        <Route path="/bump-to-birthday-book" element={<ProductDetail />} />
        <Route path="/contact-us" element={<Contactus />} />
        <Route path="/about"  element={<CMSPages />}  />
        <Route path="/shipping-and-delivery"  element={<CMSPages />} />
        <Route path="/privacy-policy"  element={<CMSPages />}  />
        <Route path="/terms-of-service" element={<CMSPages />}  />
        <Route path="/faq" element={<FAQ/>}/>
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:slug" element={<BlogDetail />} />
        <Route path="/unsubscribe" element={<NewsletterUnsubscribe />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/buy-a-voucher" element={<BuyAVoucher />} />
        </Route>

        {/* Private Routes  */}
        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/bookinfo/:id" element={<BookInfo />} />
          <Route path="/book/:id" element={<AllPages />} />
          <Route path="/success" element={<Success />} />
          <Route path="/failure" element={<Failure />} />         
          <Route path="/pdfviewer/:id" element={<ViewPdf />} />
          <Route path="/manage-account" element={<ManageAccount />} />
          <Route path="/order-history" element={<OrderHistory />} />
          <Route path="/order-details" element={<OrderDetails />} />
          <Route path="/print-order-details" element={<PrintOrderDetails />} />
          <Route path="/manage-payment-methods" element={<ManagePaymentMethods/>} />
        </Route>

        <Route element={<OnlyHeaderLayout />}>
          <Route path="/add-message" element={<AddMessage />} />
        </Route>

        <Route element={<NoHeaderFooterLayout />}>
          <Route path="/page-invite" element={<VerifyGuest />} />
        </Route>

      </Routes>
    </Suspense>)
}

export default AppRoutes